import React from "react";
import { Card, CardContent } from "Components/ui/card";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function KPICard({ label, value, change, changeType, icon: Icon }) {
  const isPositive = changeType === "up";

  return (
    <Card className="flex-1 min-w-[200px]">
      <CardContent className="p-4">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <p style={{ fontFamily: "inter-regular", fontSize: "12px", color: "#8A9BA8", marginBottom: "4px" }}>
              {label}
            </p>
            <h3 style={{ fontFamily: "Aenoik-medium", fontSize: "32px", color: "#25343F", lineHeight: 1.1 }}>
              {value}
            </h3>
            {change !== undefined && (
              <div className="d-flex align-items-center gap-1 mt-2">
                {isPositive ? (
                  <TrendingUp size={14} color="#2E7D5B" />
                ) : (
                  <TrendingDown size={14} color="#D14343" />
                )}
                <span style={{
                  fontSize: "12px",
                  fontFamily: "inter-regular",
                  color: isPositive ? "#2E7D5B" : "#D14343"
                }}>
                  {change}
                </span>
              </div>
            )}
          </div>
          {Icon && (
            <div style={{
              width: 40, height: 40, borderRadius: 10,
              background: "rgba(75,122,142,0.1)",
              display: "flex", alignItems: "center", justifyContent: "center"
            }}>
              <Icon size={20} color="#4B7A8E" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
